// extracted by mini-css-extract-plugin
module.exports = {"page-wrapper":"AdminProfilePage_page-wrapper__VtDZ-"};